// extracted by mini-css-extract-plugin
export var container = "_6g-0";
export var infoButton = "_6g-1";
export var label = "_6g-3";
export var labelExpanded = "_6g-4";
export var price = "_6g-5";
export var priceExpanded = "_6g-6";
export var title = "_6g-2";